/** @jsxImportSource @emotion/react */
import React from 'react'
import { GroupPostForm, GroupPostPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/GroupPostContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, managePost } = breadcrumbItems

const ManageNews: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, managePost]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <GroupPostForm />
        </div>
        <div css={styles.right}>
          <GroupPostPreview />
        </div>
      </div>
    </Provider>
  )
}

export default ManageNews
